import { setTestDriveDate } from '@/context/borrower';
import { EJourneys } from '@/context/display';
import { store } from '@/context/store';

export function setInitialTestDriveDate(
    date: string | null,
    initialJourney?: EJourneys
): void {
    console.log('setInitialTestDriveDate, : ', date);

    let testDriveDate: Date;

    if (!date) {
        // Check if we're in a test drive journey
        if (initialJourney === EJourneys.TEST_DRIVE) {
            // Set default to today's date
            testDriveDate = new Date();
        } else {
            return;
        }
    } else {
        // Change date format to Date object
        const dateArray = date.split('-');
        const day = parseInt(dateArray[0]);
        const month = parseInt(dateArray[1]) - 1;
        const year = parseInt(dateArray[2]);
        testDriveDate = new Date(year, month, day);
    }

    // Dispatch
    store.dispatch(setTestDriveDate(testDriveDate));
}
